var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "create-ques-form" },
    [
      _c(
        "div",
        { staticStyle: { width: "48%" } },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-col": _vm.labelCol,
                "wrapper-col": _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "标题：", prop: "name" } },
                [
                  _c("a-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "简介：", prop: "remark" } },
                [
                  _c("a-textarea", {
                    attrs: { rows: 4, type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "测评类型：", prop: "remark" } },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      placeholder: "请选择测评类型",
                      dictCode: "evaluation_type",
                      allowClear: "",
                    },
                    on: { select: _vm.selectType },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "题目数量" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入题目数量" },
                    model: {
                      value: _vm.form.num,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "num", $$v)
                      },
                      expression: "form.num",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "推荐用时" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入推荐用时" },
                    model: {
                      value: _vm.form.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "time", $$v)
                      },
                      expression: "form.time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "指标项信息：", prop: "indexItem" } },
                [
                  _c(
                    "div",
                    { staticClass: "index-item" },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "请输入指标项" },
                        on: { pressEnter: _vm.addIndexItem },
                        model: {
                          value: _vm.form.indexItem,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "indexItem", $$v)
                          },
                          expression: "form.indexItem",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: { type: "dashed", block: "" },
                          on: { click: _vm.addIndexItem },
                        },
                        [
                          _c("a-icon", { attrs: { type: "plus" } }),
                          _vm._v("\n            新增指标项\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "a-popconfirm",
                        {
                          attrs: { "ok-text": "是", "cancel-text": "否" },
                          on: {
                            confirm: _vm.confirmCancel,
                            cancel: _vm.cancel,
                          },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("p", [
                              _vm._v(
                                "新增问卷模式下，取消操作会导致未保存的表单内容丢失"
                              ),
                            ]),
                            _c("p", [_vm._v("确认要取消吗？")]),
                          ]),
                          _c("a-button", [_vm._v("取消")]),
                        ],
                        2
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { margin: "0px 12px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.saveForm },
                        },
                        [_vm._v("保存")]
                      ),
                      _c("a-button", { on: { click: _vm.nextClick } }, [
                        _vm._v("下一步"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("a-divider", {
        staticStyle: { height: "600px" },
        attrs: { type: "vertical" },
      }),
      _c(
        "div",
        { staticStyle: { width: "48%" } },
        [
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "danger",
                    ghost: "",
                    disabled: !_vm.selectedRowKeys.length,
                  },
                  on: { click: _vm.batchDeleteRow },
                },
                [_vm._v("\n        批量删除\n      ")]
              ),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              rowKey: "index",
              columns: _vm.columns,
              "data-source": _vm.tableData,
              scroll: { y: 500 },
              pagination: _vm.pagination,
              "row-selection": {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
              },
              bordered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "operation",
                fn: function (text, record, index) {
                  return _c(
                    "div",
                    { staticStyle: { cursor: "pointer" } },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#1890ff" },
                          on: {
                            click: function ($event) {
                              return _vm.editRow(record, index)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#f81d22" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRow(record, index)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("EditModal", {
        ref: "editModalRef",
        on: { updateRow: _vm.updateRow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }